import type { QueryBuilderLabels } from './types';

export const DEFAULT_QUERY_BUILDER_LABELS: QueryBuilderLabels = {
  loading: 'Loading criteria...',
  noFields: 'No fields are available to filter on.',
  matchPrefix: 'Match',
  matchSuffix: 'of the following:',
  matchAll: 'All of',
  matchAny: 'Any of',
  addRootGroup: 'Add group',
  addCondition: 'Add condition',
  addGroup: 'Add group',
  removeGroup: 'Remove group',
  removeCondition: 'Remove condition',
  negate: 'Negate',
  fieldPlaceholder: 'Select a field',
  operatorPlaceholder: 'Select an operator',
  valuePlaceholder: 'Select value(s)',
  valueWithCustomPlaceholder: 'Select or type a value',
  textValuePlaceholder: 'Value'
};
